import { useNetworkStatus } from '../hooks/useNetworkStatus'
import { useConnectionStore } from '../stores/connection'
import { queryClient } from '../lib/queryClient'

export function NetworkStatusBanner() {
  const { online } = useNetworkStatus()
  const degraded = useConnectionStore((s) => s.degraded)

  // Fully offline → static warning. Online but requests failing/timing out (e.g.
  // congested network on a city-festival day) → offer a manual retry instead of an
  // eternal spinner.
  if (online && !degraded) return null

  if (!online) {
    return (
      <div
        role="alert"
        className="w-full bg-amber-400 text-amber-900 text-sm font-medium text-center py-2 px-4 flex items-center justify-center gap-2"
      >
        <span>⚡</span>
        <span>Офлайн — данные могут быть устаревшими. Открытие аренд недоступно.</span>
      </div>
    )
  }

  const retry = () => {
    useConnectionStore.getState().setDegraded(false)
    queryClient.refetchQueries()
  }

  return (
    <div
      role="alert"
      className="w-full bg-amber-400 text-amber-900 text-sm font-medium text-center py-2 px-4 flex items-center justify-center gap-3"
    >
      <span>📶</span>
      <span>Проблемы с соединением</span>
      <button
        onClick={retry}
        className="shrink-0 bg-amber-900 text-amber-50 font-semibold px-3 py-1 rounded-lg text-xs hover:bg-amber-800"
      >
        Повторить
      </button>
    </div>
  )
}
